import React from 'react';
import './navBar.scss';
import { BACK, ENTER, RIGHT, LEFT, UP } from '../../util/remoteButtons';

export default class NavBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nav: true,
    };
    this.selectedBtn = "None";
    // this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  async componentDidMount() {
    if (this.props.subscription) {
      // this.selectedBtn = "Account";
      this.refs.account.focus();
      document.getElementById("account").classList.add("active");
    } else {
      // this.selectedBtn = "Pair";
      this.refs.pair.focus();
      document.getElementById("pair").classList.add("active");
    }
    // window.onkeyup = (e) => {
    //   console.log("Gere", this.state.nav);
    //   switch (e.which) {
    //     case RIGHT:
    //       if ((this.selectedBtn === "Pair" || this.selectedBtn === "Account") && this.props.subscription) {
    //         this.refs.settings.focus();
    //         this.selectedBtn = "Settings";
    //         if (this.props.subscription) 
    //         document.getElementById("account").classList.remove("active");
    //         else
    //         document.getElementById("pair").classList.remove("active");
    //         document.getElementById("settings").classList.add("active");
    //       } else if (this.selectedBtn === "Settings") {
    //         this.refs.help.focus();
    //         this.selectedBtn = "Help";
    //         document.getElementById("settings").classList.remove("active");
    //         document.getElementById("help").classList.add("active");
    //       }
    //       else {
    //         this.refs.help.focus();
    //         this.selectedBtn = "Help";
    //         document.getElementById("pair").classList.remove("active");
    //         document.getElementById("help").classList.add("active");
    //       }
    //       break;
    //     case LEFT:
    //       if (this.selectedBtn === "Help" && this.props.subscription) {
    //         this.refs.settings.focus();
    //         this.selectedBtn = "Settings";
    //         document.getElementById("help").classList.remove("active");
    //         document.getElementById("settings").classList.add("active");
    //       } else if (this.selectedBtn === "Settings") {
    //         if (this.props.subscription) {
    //           this.refs.account.focus();
    //           this.selectedBtn = "Account";
    //           document.getElementById("settings").classList.remove("active");
    //           document.getElementById("account").classList.add("active");
    //         }
    //         else {
    //           this.refs.pair.focus();
    //           this.selectedBtn = "Pair";
    //           document.getElementById("settings").classList.remove("active");
    //         document.getElementById("pair").classList.add("active");
    //         }
    //       }
    //       else {
    //         this.refs.pair.focus();
    //         this.selectedBtn = "Pair";
    //         document.getElementById("help").classList.remove("active");
    //         document.getElementById("pair").classList.add("active");
    //       }
    //       break;
    //     case ENTER:
    //       if(this.state.nav) {
    //         if (this.selectedBtn === 'Account') {
    //           this.selectedBtn = 'None';
    //           this.props.onNavigation('Account');
    //         } else if (this.selectedBtn === 'Pair') {
    //           this.selectedBtn = 'None';
    //           this.props.onNavigation('Pair');
    //         } else if (this.selectedBtn === 'Settings') {
    //           this.selectedBtn = 'None';
    //           this.props.onNavigation('Settings');
    //         }
    //       }
    //       break;
    //     case 27:
    //     case BACK:
    //       this.setState({nav: false});
    //       this.props.onNavigation("Hide");
    //       break;
    //   }
    // };
  }
  

  handleClick(navTo) {
    this.props.onNavigation(navTo);
  }

  render() {
    return (
      <div className="navBar" ref="topBar" onKeyDown={this.handleKeyDown}>
        {/* <div className="navBar_active" id="active"></div> */}
        <div className="navBar_pages">
          {this.props.subscription ?
            <div className="navBar_pages_item account" id="account" style={{ left: '0px' }}>
              <div className="navBar_pages_item_text">Account</div>
              <div className="navBar_pages_item_imgWrapper" ref="account">
                <img src="/assets/img/account.png" className="navBar_pages_item_imgWrapper_img" />
              </div>
            </div>
            :
            <div className="navBar_pages_item account" id="pair" style={{ left: '0px' }}>
              <div className="navBar_pages_item_text">Pair Device</div>
              <div className="navBar_pages_item_imgWrapper" ref="pair">
                <img src="/assets/img/pair.png" className="navBar_pages_item_imgWrapper_img" />
              </div>
            </div>
          }
          <div className="navBar_pages_item settings" id="settings">
            <div className="navBar_pages_item_text">Settings</div>
            <div className="navBar_pages_item_imgWrapper" ref="settings">
              <img src="/assets/img/settings.png" className="navBar_pages_item_imgWrapper_img" style={{ left: '330px' }} />
            </div>
          </div>
          <div className="navBar_pages_item help" id="help">
            <div className="navBar_pages_item_text">Help</div>
            <div className="navBar_pages_item_imgWrapper" ref="help">
              <img src="/assets/img/help.png" className="navBar_pages_item_imgWrapper_img" style={{ left: '600px' }} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
